export default "__VITE_ASSET__D43CGX23__"